import React, { useState } from 'react';
// @ts-ignore
import styles from './SearchMedicamentRecordListItemMedicament.module.scss';
import Text from '../../../Base/Text/Text';
import LinkButton from '../../../Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import { getMomentDate } from '../../../../Utils/dates.util';

export interface SearchMedicamentRecordListItemMedicamentScheme {
	title: string;
	subtitle?: string;
	issuedAt?: string;
	items: {
		title: string;
		value: string;
	}[];
	children: {
		title: string;
		children: {
			title?: string;
			value: string;
		}[];
	}[];
}

interface Props {
	item: SearchMedicamentRecordListItemMedicamentScheme;
}

const SearchMedicamentRecordListItemMedicament: React.FC<Props> = ({
	item,
}) => {
	const [isDetailOpen, setIsDetailOpen] = useState(false);

	const handleToggleDetail = () => {
		setIsDetailOpen(!isDetailOpen);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<>
					<div className={styles.medicament}>
						<div className={styles.title}>
							{item.title} <span>{item.subtitle}</span>
						</div>
						{item.issuedAt && (
							<div className={styles.date}>
								<Text tx={'base.issued'} inline firstUpper />:{' '}
								{getMomentDate(item.issuedAt).format('DD.MM.yyyy')}
							</div>
						)}
					</div>
					<div className={styles.prescriptBy}>
						{item.items.map(subItem => (
							<div className={styles.prescriptByItem}>
								<div className={styles.name}>{subItem.title}:</div>
								<div className={styles.value}>{subItem.value}</div>
							</div>
						))}
					</div>
					{isDetailOpen && (
						<>
							{item.children.map(child => (
								<div>
									<div className={styles.detailTitle}>{child.title}</div>
									<div className={styles.prescriptBy}>
										{child.children.map(subChild => (
											<div className={styles.prescriptByItem}>
												{subChild.title && (
													<div className={styles.name}>{subChild.title}:</div>
												)}
												<div className={styles.value}>{subChild.value}</div>
											</div>
										))}
									</div>
								</div>
							))}
						</>
					)}
				</>
			</div>
			<div className={styles.controls}>
				<LinkButton
					onClick={handleToggleDetail}
					title={'base.detail'}
					firstUpper
					theme={Theme.BLUE}
				/>
			</div>
		</div>
	);
};

export default SearchMedicamentRecordListItemMedicament;
